import { render, staticRenderFns } from "./HomeAttivita.vue?vue&type=template&id=21e5f5bc&"
import script from "./HomeAttivita.vue?vue&type=script&lang=js&"
export * from "./HomeAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports